module.exports = __webpack_public_path__ + "static/media/solutions.d8fc0b1e.png";